module.exports = __webpack_public_path__ + "img/25.5.COD.458d0ffb.png";